import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import { paths } from '@/core/router/paths';
import { generateQueryString } from '@/utils/url/generateQueryString';

import { QuickSearch } from '../QuickSearch/QuickSearch';

import { mainSearchBarSearchStyles as sx } from './MainSearchBar.styles';

type Props = {
	fullWidth?: boolean;
	fullHeight?: boolean;
};

export const MainSearchBar = ({
	fullWidth = false,
	fullHeight = false
}: Props) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [input, setInput] = useState('');

	const handleSearch = useCallback(
		(value: string) => {
			navigate({
				pathname: paths.searchHcp,
				search: generateQueryString({
					name: value
				})
			});
		},
		[navigate]
	);

	const handleChange = (value: string) => {
		setInput(value);
	};

	return (
		<>
			<QuickSearch
				value={input}
				onChange={handleChange}
				placeholder='Search OpenData'
				handleSearch={handleSearch}
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus
				disableDropdownOnLoad
				customSx={{
					root: sx.root(fullWidth, fullHeight),
					searchRoot: sx.searchRoot,
					searchInput: sx.searchInput,
					searchIcon: sx.searchIcon,
					dropdown: sx.dropdown,
					popper: {
						minWidth: 'unset'
					}
				}}
			/>

			<Box sx={sx.linkBox}>
				<Link to={paths.searchHcp} component={RouterLink} sx={sx.link}>
					{t('Advanced Search')}
				</Link>
			</Box>
		</>
	);
};
